// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const CreditMemoCriteriaFooter = props =>
    <div className='credit-memo-criteria-footer'>
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div>
        <div className='button-group'>
            <button
                className='secondary-button'
                onClick={props.handleCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!props.canRunReport}
                onClick={props.onRunReport}
                type='button'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    </div>;

CreditMemoCriteriaFooter.displayName = 'CreditMemoCriteriaFooter';
CreditMemoCriteriaFooter.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired
};

export default CreditMemoCriteriaFooter;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/criteria-footer.js